<template>
    <v-col
        :cols="width"
    >
        <v-slider
            :disabled="readonly"
            :name="item.name"
            :rules="rules"
            :tick-labels="slider_labels"
            max="4"
            min="0"
            ref="input"
            tick-size="5"
            ticks="always"
            v-model="modelData" >

            <template v-if="item.props.tooltip" v-slot:append>
                <v-tooltip
                    top
                >
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information</v-icon>
                    </template>
                    <div v-html="item.props.tooltip"></div>
                </v-tooltip>
            </template>

        </v-slider>
    </v-col>
</template>
<script>
    export default {
        name: 'Slider',
        props: ['item', 'value', 'readonly', 'rules', 'width'],
        computed: {
            modelData: {
                get: function () {
                    return this.value;
                },
                set: function (newVal) {
                    this.$emit('input', newVal);
                }
            }
        },
        data: () => ({
            slider_labels: []
        }),
        mounted() {
            this.convertLabels()
        },
        methods: {
            convertLabels: function () {
                let sliderLabels = this.item.props.labels

                for (let l in sliderLabels) {
                    if(sliderLabels[l] == 'undefined') {
                        sliderLabels[l] = undefined
                    }
                }
                //console.log(sliderLabels)
                this.slider_labels = sliderLabels
            },
            validate: function () {
                return this.$refs.input.validate();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/questionnaire_template/slider.vue